import React from 'react';

export const EscapedTag = ({ tag:Tag = 'p', children = '', ...props }) => (
  <Tag {...props} dangerouslySetInnerHTML={{__html: String(children).replace(new RegExp(`(\\<\\/?${Tag}\\s?\\>|\\<${Tag}\\s?\\/\\>)`, 'g'), '').replace(/\s/, ' ')}} />
);

export default EscapedTag;
